import { Button } from '@yes.technology/react-toolkit'
import styled from 'styled-components'

export const Container = styled.div`
  background-color: #f7f8fa;
  position: relative;
  display: flex;
`

export const ImageContainer = styled.div`
  display: none;

  @media (min-width: 768px) {
    display: block;
    background-repeat: no-repeat;
    background-size: contain;
    flex: 0 0 175px;
  }

  @media (min-width: 1920px) {
    flex-basis: 210px;
  }
`

export const LeftImageContainer = styled(ImageContainer)<{
  backgroundImage?: string
}>`
  background-position: left center;
  background-image: ${(props) =>
    props.backgroundImage ? `url(${props.backgroundImage})` : 'none'};
`

export const RightImageContainer = styled(ImageContainer)<{
  backgroundImage?: string
}>`
  background-position: right center;
  background-image: ${(props) =>
    props.backgroundImage ? `url(${props.backgroundImage})` : 'none'};
`

export const ContentWrapper = styled.div`
  padding: 1.5rem 1rem;
  position: relative;
  z-index: 1;
  flex: 1 1 auto;

  @media (min-width: 768px) {
    display: flex;
    justify-content: space-between;
    max-width: 1220px;
    flex-direction: column;
    margin: 0 auto;
    gap: 1.5rem;
    padding: 1rem 0;
  }
`

export const Text = styled.h2`
  color: #303032;
  text-align: center;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;

  @media (min-width: 768px) {
    font-size: 32px;
    margin: 0 auto;
  }
`

export const StyledButton = styled(Button)`
  margin-inline: auto;
  width: 100%;
  max-width: 300px;
`

export const Link = styled.a`
  :hover {
    text-decoration: none;
  }

  :focus-visible {
    outline: none;
  }
`
